import React, { useEffect, useState } from "react";

const TARGET = new Date("2026-06-22T15:00:00").getTime();

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown() {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = Math.max(0, TARGET - now);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  const units = [
    { label: "Jours", value: pad(days) },
    { label: "Heures", value: pad(hours) },
    { label: "Minutes", value: pad(minutes) },
    { label: "Secondes", value: pad(seconds) },
  ];

  return (
    <div data-testid="countdown" className="grid grid-cols-4 gap-3 md:gap-6 max-w-3xl">
      {units.map((u) => (
        <div
          key={u.label}
          data-testid={`countdown-${u.label.toLowerCase()}`}
          className="romantic-card rounded-2xl py-6 md:py-10 px-2 md:px-4 text-center transition-all duration-500"
        >
          <div className="font-serif text-4xl md:text-6xl lg:text-7xl text-rose-50 tabular-nums">
            {u.value}
          </div>
          <div className="text-xs md:text-sm tracking-[0.3em] uppercase text-rose-300/80 mt-2 md:mt-3">
            {u.label}
          </div>
        </div>
      ))}
    </div>
  );
}
